import { Link } from "react-router-dom";
import {
  LogIn,
  ShieldAlert,
  ArrowRight,
} from "lucide-react";

import {
  Card,
  CardContent,
  Button,
} from "../components/ui";

const LOGO_URL =
  "https://res.cloudinary.com/hsvfv0h8/image/upload/v1786152037/Untitled_design__6_-removebg-preview_zijzg4.png";

const GoogleAuth = () => {
  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
  };

  return (
    <div className="min-h-screen bg-neutral-50/50 flex items-center justify-center p-4 sm:p-6 antialiased relative">

      {/* =========================================================
          TOP-LEFT BRAND LOGO
          ========================================================= */}
      <div className="absolute top-5 left-6 sm:top-6 sm:left-8 lg:top-7 lg:left-10 z-20">
        <img
          src={LOGO_URL}
          alt="Company logo"
          className="
            w-auto
            h-auto
            max-w-[120px]
            max-h-[72px]
            object-contain
          "
          loading="eager"
          decoding="async"
        />
      </div>

      {/* =========================================================
          AUTHENTICATION CARD
          ========================================================= */}
      <div className="w-full max-w-md">

        <Card className="w-full border border-neutral-200 bg-white dark:bg-neutral-900 shadow-none rounded-2xl overflow-hidden">

          <CardContent className="px-6 py-7 sm:px-8 sm:py-8">

            {/* Heading */}
            <div className="text-center mb-6">
              <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-neutral-900 dark:text-neutral-100">
              Welcome Back!
              </h1>

              <p className="mt-1.5 text-xs text-neutral-500 dark:text-neutral-400">
                Sign in to continue to your account
              </p>
            </div>

            {/* Google Sign In */}
            <button
              type="button"
              onClick={handleGoogleLogin}
              aria-label="Continue with Google"
              className="
                w-full
                h-11
                bg-white
                dark:bg-neutral-900
                hover:bg-neutral-50
                dark:hover:bg-neutral-800
                active:bg-neutral-100
                dark:active:bg-neutral-800
                text-neutral-800
                dark:text-neutral-100
                font-medium
                text-sm
                px-4
                rounded-lg
                border
                border-neutral-200
                dark:border-neutral-700
                transition-all
                duration-200
                flex
                items-center
                justify-center
                gap-3
                shadow-sm
                hover:shadow
                focus:outline-none
                focus:ring-2
                focus:ring-primary-500/20
                focus:border-primary-500/50
                group
              "
            >
              {/* Google Icon */}
              <svg
                className="w-5 h-5 flex-shrink-0 transition-transform duration-200 group-hover:scale-105"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fill="#EA4335"
                  d="M5.266 9.765A7.077 7.077 0 0 1 12 4.909c1.69 0 3.218.6 4.418 1.582l3.51-3.51C17.642 1.09 14.974 0 12 0 7.354 0 3.307 2.67 1.242 6.56l4.024 3.205z"
                />

                <path
                  fill="#4285F4"
                  d="M23.491 12.275c0-.796-.073-1.564-.2-2.305H12v4.51h6.464a5.534 5.534 0 0 1-2.4 3.632l3.781 2.93c2.213-2.037 3.646-5.042 3.646-8.767z"
                />

                <path
                  fill="#FBBC05"
                  d="M5.266 14.235L1.242 17.44A11.966 11.966 0 0 1 0 12c0-1.92.454-3.734 1.242-5.44l4.024 3.205a7.078 7.078 0 0 0 0 4.47z"
                />

                <path
                  fill="#34A853"
                  d="M12 24c3.24 0 5.956-1.077 7.942-2.923l-3.78-2.93c-1.047.7-2.391 1.118-4.162 1.118-3.214 0-5.936-2.17-6.91-5.102L1.066 17.37A11.964 11.964 0 0 0 12 24z"
                />
              </svg>

              <span>Continue with Google</span>
            </button>

            {/* Divider */}
            <div className="relative flex items-center my-6">
              <div className="flex-1 border-t border-neutral-200 dark:border-neutral-800" />

              <span className="mx-3 bg-white dark:bg-neutral-900 px-1 text-xs font-medium text-neutral-400 dark:text-neutral-500">
                or
              </span>

              <div className="flex-1 border-t border-neutral-200 dark:border-neutral-800" />
            </div>

            {/* Email Login */}
            <Link to="/login" className="block">
              <Button
                type="button"
                variant="primary"
                leftIcon={<LogIn className="w-4 h-4" />}
                className="w-full h-11 text-sm font-semibold rounded-lg"
              >
                Login with Email
              </Button>
            </Link>

            {/* Security Notice */}
            <div className="mt-5 flex items-start gap-2.5 p-3 bg-neutral-50 dark:bg-neutral-950 rounded-lg border border-neutral-100 dark:border-neutral-800">
              <ShieldAlert className="w-4 h-4 text-amber-500 mt-0.5 shrink-0" />

              <p className="text-[11px] leading-relaxed text-neutral-500 dark:text-neutral-400">
                Authorized access only. Actions on this panel are securely
                logged.
              </p>
            </div>

            {/* Bottom Navigation */}
            <div className="mt-6 pt-5 border-t border-neutral-100 dark:border-neutral-800">

              {/* Signup */}
              <p className="text-center text-xs text-neutral-500 dark:text-neutral-400">
                Don't have an account?

                <Link
                  to="/signup"
                  className="font-semibold text-primary-600 dark:text-primary-400 hover:underline ml-1"
                >
                  Sign up
                </Link>
              </p>

              {/* Other Portals */}
             
            </div>

          </CardContent>
        </Card>

        {/* Footer */}
        <p className="text-center text-[11px] text-neutral-400 dark:text-neutral-500 mt-5">
          © {new Date().getFullYear()} All rights reserved.
        </p>

      </div>
    </div>
  );
};

export default GoogleAuth;